module.exports = __webpack_public_path__ + "img/jiuchang.9c436bc8.jpg";